import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyKnownError, thunkErrorHandler } from 'features/thunkError';
import { AppDispatch } from 'app/store';
import { IAddress, ICustomer, ITaxIdInfo } from './customerTypes';
import {
  addCustomerPaymentCard,
  fetchCustomerById,
  fetchCustomerByOrganozationId,
  setCustomerDefaultPaymentMethod,
  updateCustomerInfo
} from 'api/billing/customers';

export const getCustomerById = createAsyncThunk<
  ICustomer,
  string,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@customer/getCustomerById', async (id, thunkApi) => {
  try {
    const res = await fetchCustomerById(id);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const getCustomerByOrganizationId = createAsyncThunk<
  ICustomer,
  number,
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@customer/getCustomerByOrganozationId', async (id, thunkApi) => {
  try {
    const res = await fetchCustomerByOrganozationId(id);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const updateCustomer = createAsyncThunk<
  ICustomer,
  {
    customerId: string;
    address: IAddress | null;
    enableAutomaticTax: boolean | null;
    taxIds: ITaxIdInfo[];
  },
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@customer/updateCustomer', async ({ customerId, address, enableAutomaticTax, taxIds }, thunkApi) => {
  try {
    const res = await updateCustomerInfo(customerId, address, enableAutomaticTax, taxIds);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const updateCustomerDefaultPaymentMethod = createAsyncThunk<
  ICustomer,
  { customerId: string; paymentMethodId: string },
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@customer/updateCustomerDefaultPaymentMethod', async ({ customerId, paymentMethodId }, thunkApi) => {
  try {
    const res = await setCustomerDefaultPaymentMethod(customerId, paymentMethodId);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});

export const addPaymentCard = createAsyncThunk<
  ICustomer,
  { customerId: string; cardToken: string },
  {
    dispatch: AppDispatch;
    rejectValue: string | unknown;
  }
>('@@customer/addPaymentCard', async ({ customerId, cardToken }, thunkApi) => {
  try {
    const res = await addCustomerPaymentCard(customerId, cardToken);
    return res.data;
  } catch (err) {
    return thunkErrorHandler(err as MyKnownError, thunkApi.rejectWithValue);
  }
});
